import React from 'react'
import { Grid, Text } from 'components'

const Home = () => {
    return (
        <Grid contentY="start" itemsX="center" padding="2em">
            <Text size={7}>Home Page</Text>
        </Grid >
    )
}

export default Home
